<template>
	<div class="full-image" v-if="show" @click="hideContextMenu">
		<div class="mask"></div>
		<div class="image-box" @contextmenu.prevent="showContextMenu($event)">
			<img :src="url" />
		</div>
		<div class="close" @click="close"><i class="el-icon-close"></i></div>
		<div
			ref="contextMenu"
			class="context-menu"
			v-if="ctxMenu.show"
			:style="{ left: ctxMenu.x + 'px', top: ctxMenu.y + 'px' }"
			@click.stop
		>
			<div class="context-menu-item" @click="copyImage">
				<i class="el-icon-copy-document"></i>
				<span>复制图片</span>
			</div>
		</div>
	</div>
</template>

<script>
import { copyImageToClipboard } from "../../utils/image";
export default {
	name: "fullImage",
	data() {
		return {
			show: false,
			url: '',
			ctxMenu: {
				show: false,
				x: 0,
				y: 0
			}
		}
	},
	methods: {
		open(url) {
			this.show = true;
			this.url = url;
		},
		close() {
			this.show = false;
			this.hideContextMenu();
		},
		showContextMenu(e) {
			this.ctxMenu.x = e.clientX;
			this.ctxMenu.y = e.clientY;
			this.ctxMenu.show = true;
			this.$nextTick(() => {
				const menu = this.$refs.contextMenu;
				if (!menu) {
					return;
				}
				const rect = menu.getBoundingClientRect();
				let x = e.clientX;
				let y = e.clientY;
				if (x + rect.width > window.innerWidth) {
					x = window.innerWidth - rect.width - 8;
				}
				if (y + rect.height > window.innerHeight) {
					y = window.innerHeight - rect.height - 8;
				}
				this.ctxMenu.x = Math.max(4, x);
				this.ctxMenu.y = Math.max(4, y);
			});
		},
		hideContextMenu() {
			this.show = false;
			if (this.ctxMenu.show) {
				this.ctxMenu.show = false;
			}
		},
		async copyImage() {
			this.hideContextMenu();
			try {
				await copyImageToClipboard(this.url);
				if (this.$message) {
					this.$message.success('图片已复制到剪贴板');
				}
			} catch (err) {
				console.error('复制图片失败:', err);
				if (this.$message) {
					this.$message.error('复制失败，请检查网络或浏览器权限');
				}
			}
		}
	}
}
</script>

<style lang="scss">
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.5;
	}

	.image-box {
		position: relative;
		width: 100%;
		height: 100%;

		img {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			max-height: 100%;
			max-width: 100%;
		}
	}

	.close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 20px;
		right: 20px;
		cursor: pointer;
		background: #333;
		border-radius: 50%;
		padding: 10px;
		opacity: 0.5;

		i {
			font-weight: bold;
			font-size: 20px;
			color: white;
		}
	}

	.context-menu {
		position: fixed;
		z-index: 10000;
		min-width: 130px;
		padding: 6px 0;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

		.context-menu-item {
			display: flex;
			align-items: center;
			padding: 9px 16px;
			font-size: 14px;
			color: #333;
			cursor: pointer;

			i {
				margin-right: 8px;
				font-size: 16px;
			}

			&:hover {
				background: #f5f5f5;
			}
		}
	}
}
</style>
